import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@ifeng-fe/public_method';
import Slides from '@ifeng-fe/ui_pc_slides';
import errorBoundary from '@ifeng-fe/errorBoundary';

const TumourShot = ({ content }) => {
    const sliderTmpl = (item, index) => {
        return (
            <a href={item.url} key={index} target="_blank" className={styles.tumourShotItem}>
                <img className={styles.tumourShotImage} src={formatImage(item?.thumbnail, 314, 176)} alt="" />
                <div className={styles.tumourShotTitle}>
                    {item.title}
                </div>
                <div className={styles.tumourShotBref}>
                    {item.summary}
                </div>
            </a>
        );
    };

    const config = {
        arrows: content.tumourShotList.length > 3,
        dots: false,
        autoplay: content.tumourShotList.length > 3,
        dotsAction: 'hover',
        unitSize: 340,
        extension: 3,
        autoplayInterval: 15000,
        infinite: content.tumourShotList.length > 3,
        sliderTmpl,
    };

    return (
        <div className={styles.column}> 
            <div
                className={styles.tumourShotTh}
                style={{ backgroundImage: `url(${content.mouldeBigImage})` }}
            >
                {content.title}
            </div>
            <div className={styles.tumourShotList}>
                <div className={styles.tumourShotBox}>
                    <Slides content={content.tumourShotList} config={config} />
                </div>
            </div>
        </div>
    );
};

TumourShot.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(TumourShot);
